import { styled } from '@mui/material/styles';
import Button from '../../../Button/Button.js';
import '../../../Button/SplitButton.js';

const ToolbarButton = styled(Button, { shouldForwardProp: prop => prop !== 'rtl' }) `
  ${({ rtl }) => `
    margin-left: ${rtl ? '8px' : '0'};
    margin-right: ${rtl ? '0' : '8px'};
  `}
`;

export { ToolbarButton as default };
//# sourceMappingURL=ToolbarButton.js.map
